'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reduceLinkedList = require('./reduce-linked-list.js');
var findLinkedList = require('./find-linked-list.js');
var whileLinkedList = require('./while-linked-list.js');
var linkedListUtils = require('./linked-list-utils.js');
var removeLinkedList = require('./remove-linked-list.js');
var insertLinkedList = require('./insert-linked-list.js');
var getLinkedList = require('./get-linked-list.js');
var updateLinkedList = require('./update-linked-list.js');
var applyDiffLinkedList = require('./apply-diff-linked-list.js');

const createLinkedList = (headId, items) => {
    const head = headId ? items[headId] : null;
    if (head === undefined) {
        throw new Error('Cannot find the head.');
    }
    const list = { headId, items };
    const { format, count } = linkedListUtils.walkListItemRecord((acc, current) => {
        const newCount = acc.count + 1;
        const currentNodeFormat = current.previousId !== undefined ? 'double' : 'single';
        const incompatibleFormats = acc.format !== null && acc.format !== currentNodeFormat;
        if (incompatibleFormats || (currentNodeFormat === 'double' && current.previousId !== acc.previousId)) {
            throw new Error('Invalid previous node in the linked list');
        }
        return {
            result: {
                previousId: current.id,
                format: currentNodeFormat,
                count: newCount,
            },
        };
    }, {
        initValue: {
            format: null,
            count: 0,
            previousId: null,
        },
        startId: headId,
        items,
    });
    const manipulationConfig = {
        factory: (newList) => createLinkedList(newList.headId, newList.items),
        /**
         * At this point isDoubleLinked cannot be undefined
         */
        format,
        list,
    };
    const linkedList = {
        head,
        items,
        format,
        size: count,
        reduce: (cb, initValue) => reduceLinkedList.reduceLinkedList(cb, initValue, list),
        find: (predicate) => findLinkedList.findLinkedList(predicate, list),
        while: (predicate, startId) => whileLinkedList.whileLinkedList(predicate, list, startId),
        remove: (id) => removeLinkedList.removeLinkedList(id, manipulationConfig),
        insert: (item) => insertLinkedList.insertLinkedList(item, manipulationConfig),
        get: (id) => getLinkedList.getLinkedList(id, list),
        update: (item) => updateLinkedList.updateLinkedList(item, manipulationConfig),
        applyDiff: (before, after) => applyDiffLinkedList.applyDiffLinkedList(before, after, linkedList),
    };
    return linkedList;
};

exports.createLinkedList = createLinkedList;
//# sourceMappingURL=create-linked-list.js.map
